import React, { useEffect, useRef, useState } from "react";
import { LANGS, LANG_LABEL, LANG_FLAG, type Lang } from "../i18n/translations";

export default function LangDropdown({
  lang,
  onChange
}: {
  lang: Lang;
  onChange: (l: Lang) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onDoc = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "8px 10px",
          borderRadius: 10,
          border: "1px solid #e5e7eb",
          background: "white",
          cursor: "pointer",
          fontSize: 13
        }}
      >
        {LANG_FLAG[lang]} {LANG_LABEL[lang]} <span style={{ opacity: 0.6 }}>▾</span>
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            right: 0,
            top: "calc(100% + 8px)",
            minWidth: 180,
            borderRadius: 12,
            border: "1px solid #e5e7eb",
            background: "white",
            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
            padding: 6,
            zIndex: 9999
          }}
        >
          {LANGS.map((l) => (
            <button
              key={l}
              type="button"
              onClick={() => {
                onChange(l);
                setOpen(false);
              }}
              style={{
                width: "100%",
                textAlign: "left",
                padding: "8px 10px",
                borderRadius: 10,
                border: "none",
                background: l === lang ? "#f3f4f6" : "transparent",
                cursor: "pointer",
                fontSize: 13,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ width: 22, textAlign: "center" }}>{LANG_FLAG[l]}</span>
                <span>{LANG_LABEL[l]}</span>
              </span>

              {l === lang ? <span>✓</span> : null}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
